import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ISection } from "../sectionModel";

export const getAllSection = createAsyncThunk(
  "Section/FindAllSection",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Section/FindAllSection`,
        {}
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Section:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createSection = createAsyncThunk(
  "Section/InsertSection",
  async (SectionData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Section/InsertSection`,
        SectionData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Section:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateSection = createAsyncThunk(
  "Section/UpdateSection",
  async (SectionData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Section/UpdateSection`,
        SectionData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Section :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteSection = createAsyncThunk(
  "Section/DeleteSection",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Section/DeleteSection`,
        {
          ID: ID,
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Section :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getSectionByID = createAsyncThunk(
  "Section/FindByIDSection",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Section/FindByIDSection`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        TagLine: result?.TagLine,
        Title: result?.Title,
        SubTitle: result?.SubTitle || "",
        URL: result?.URL,
        SectorID: result.SectorID,
        Position: `${result.Position}`,
        Image: result.Image,
        IsActive: result.IsActive ? 1 : 2,
      } as ISection;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Section :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveSection = createAsyncThunk(
  "Section/FindAllActiveSection",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Section/FindAllActiveSection`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Sections:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveSection = createAsyncThunk(
  "Section/ActiveInActiveSection",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Section/ActiveInActiveSection`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Section :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const sectionImageUpload = createAsyncThunk(
  "Section/SectionImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Section/SectionImageUpdate`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Section Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
